import { observer } from 'mobx-react';
import AmazonMcfCredentialsStore from "../../../stores/credentials/amazon-mcf-credentials-store";
import {SelectDropdown} from "../../../../../../components/inputs/select-dropdown/select-dropdown";
import React from "react";
import {IValidationGroup} from "../../../../../../hooks/validation-group/validation-group-hook";
import {FormFieldLine} from "../../../../../../components/form-field-line/form-field-line";


interface IIntegrationProps {
    credentialsStore: AmazonMcfCredentialsStore,
    vGroup?: IValidationGroup,
}

const AmazonMcfCredentials: React.FC<IIntegrationProps> = observer(({credentialsStore, vGroup}) => {
    return (
        <>
            <FormFieldLine 
                gridStyle={{ lableWidth: { width: 1, type: 'fr' }, childrenWidth: { width: 2.5, type: 'fr' } }}
                label='Seller Central Login URL' required key='seller_central_url'>
                <SelectDropdown
                    value={AmazonMcfCredentialsStore.SELLER_CENTRAL_URL_OPTIONS.find((option) => {
                            return option.value === credentialsStore.sellerCentralUrlOption.value}
                    ) || AmazonMcfCredentialsStore.SELLER_CENTRAL_URL_OPTIONS[0]}
                    options={ AmazonMcfCredentialsStore.SELLER_CENTRAL_URL_OPTIONS }
                    onChange={ (option) => {
                        if (option) {
                            credentialsStore.setSellerCentralUrlOption(option.value as string);
                        }
                    }}
                    note={ "Select the country you use for logging into Seller Central"}
                />
            </FormFieldLine>
            <FormFieldLine
                gridStyle={{ lableWidth: { width: 1, type: 'fr' }, childrenWidth: { width: 2.5, type: 'fr' } }}
                label='MCF Connector' required key='mcf_connector'>
                <SelectDropdown
                    value={
                        AmazonMcfCredentialsStore.MCF_CONNECTORS.find((option) => {
                            return option.value === credentialsStore.mcfConnector.value}
                        ) || AmazonMcfCredentialsStore.MCF_CONNECTORS[3]
                    }
                    options={ AmazonMcfCredentialsStore.MCF_CONNECTORS }
                    onChange={ (option) => {
                        if (option) {
                            credentialsStore.setMcfConnector(option.value as string);
                        }
                    }}
                    note={ "Select the app used to export orders from your store to MCF"}
                />
            </FormFieldLine>
        </>
    )
});

export default AmazonMcfCredentials;
